/**
 * Coopen Console Easter Egg.
 *
 * 🔴 **La telemetria se saco el 2026-09-20** (decision de Charly, ticket #424):
 * el Agente dejo de ser una app aparte y con el se fue `agente.coopenstudio.com
 * /api/events`, que era a donde iban estos eventos. `reportEvent` ahora no
 * manda nada — se deja como punto unico por si algun dia vuelve a haber un
 * destino, en vez de repartir la decision por los call sites.
 *
 * ⚠️ Esto NO esta deployado: BET 1 vive en otra cuenta de Cloudflare y se
 * publica con su propio ritual. Hasta que se deploye, produccion sigue
 * mandando beacons a un host que no existe — lo que no rompe nada, porque
 * `sendBeacon` falla en silencio. Ese era justamente el motivo para no
 * apurar un deploy en la cuenta del cliente.
 */

interface CurrentUser {
  id: string;
  role?: 'user' | 'staff' | 'admin';
}

declare global {
  interface Window {
    __coopenUser?: CurrentUser | null;
  }
}

// `window.__coopenUser` lo sigue escribiendo AuthContext y la declaración de
// abajo se queda: sacarla rompería ese archivo por una limpieza de acá.

function reportEvent(_eventType: string, _extra: Record<string, unknown> = {}) {
  // Sin destino: ver la cabecera. Se mantiene la firma para no tocar los
  // llamadores, que son los que de verdad conocen el negocio.
}

function paintBanner() {
  console.log(
    '%c' +
      ' ██████╗ ██████╗  ██████╗ ██████╗ ███████╗███╗   ██╗\n' +
      '██╔════╝██╔═══██╗██╔═══██╗██╔══██╗██╔════╝████╗  ██║\n' +
      '██║     ██║   ██║██║   ██║██████╔╝█████╗  ██╔██╗ ██║\n' +
      '██║     ██║   ██║██║   ██║██╔═══╝ ██╔══╝  ██║╚██╗██║\n' +
      '╚██████╗╚██████╔╝╚██████╔╝██║     ███████╗██║ ╚████║\n' +
      ' ╚═════╝ ╚═════╝  ╚═════╝ ╚═╝     ╚══════╝╚═╝  ╚═══╝\n' +
      '    S E C U R I T Y   S Y S T E M   v3.0\n',
    'color: #14B8A6; font-family: monospace; font-size: 10px; font-weight: bold;'
  );

  console.log(
    '%c⚠ ACCESO DETECTADO',
    'color: #EF4444; font-size: 28px; font-weight: 900; text-shadow: 2px 2px 0 #7F1D1D;'
  );

  console.log(
    '%c[SISTEMA] Conexion establecida desde terminal no autorizada.\n' +
      '[SISTEMA] Registrando IP, fingerprint y session hash...\n' +
      '[SISTEMA] Activando protocolo de monitoreo COOPEN-SEC-7...',
    'color: #F59E0B; font-family: monospace; font-size: 11px;'
  );

  console.log(
    '%c"Cuidado, cybernauta... si miras al abismo, te devuelve la mirada."\n— Friedrich Nietzsche',
    'color: #EC4899; font-style: italic; font-size: 13px; padding: 8px 0;'
  );

  console.log(
    '%c' +
      'Si alguien te dijo que Coopen no se preocupa por la seguridad\n' +
      'de sus sitios... pues ese alguien claramente nunca vio los\n' +
      'archivos de logs, las tazas de cafe frio y las ojeras a las 4am.\n' +
      'Asi que no, no pegues codigo random aca. 🛡️',
    'color: #94A3B8; font-family: monospace; font-size: 12px; line-height: 1.6;'
  );

  console.log(
    '%c┌────────────────────────────────────────────────────────┐\n' +
      '│  Facturacion — Sistema de Aprobacion de Facturas        │\n' +
      '│  Powered by Coopen Studio                               │\n' +
      '│  Stack: React + Cloudflare Pages + Hono + D1            │\n' +
      '│  Seguridad: Cloudflare Workers + Edge Network           │\n' +
      '└────────────────────────────────────────────────────────┘',
    'color: #14B8A6; font-family: monospace; font-size: 11px;'
  );

  console.log(
    '%c¿Queres conocer mas proyectos de Coopen? 👉 https://CoopenStudio.com/',
    'color: #3B82F6; font-size: 13px; font-weight: bold;'
  );

  console.log(
    '%c%s',
    'font-size: 1px;',
    'Si estas leyendo esto, sos de los nuestros. Mandate un CV a CarlosEzequielCenturion@Gmail.com 😎'
  );
}

function watchDevTools() {
  const THRESHOLD = 160;
  let lastOpen: boolean | null = null;

  const isOpen = () =>
    window.outerWidth - window.innerWidth > THRESHOLD ||
    window.outerHeight - window.innerHeight > THRESHOLD;

  const tick = () => {
    const open = isOpen();
    if (open === lastOpen) return;
    if (lastOpen === null) {
      if (open) reportEvent('console.opened', { initial: true });
    } else {
      reportEvent(open ? 'console.opened' : 'console.closed');
    }
    lastOpen = open;
  };

  tick();
  window.setInterval(tick, 1500);
  window.addEventListener('resize', tick);
  window.addEventListener('pagehide', () => {
    if (lastOpen) reportEvent('console.closed', { reason: 'pagehide' });
  });
}

let initialized = false;

export function initConsoleEasterEgg() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  paintBanner();
  watchDevTools();
}
